import { ElementObserver } from "./element_observer";
import { IndexedMultimap } from "@stimulus/multimap";

var TokenListObserver =
/** @class */
function () {
  function TokenListObserver(element, attributeName, delegate) {
    this.attributeName = attributeName;
    this.delegate = delegate;
    this.elementObserver = new ElementObserver(element, this);
    this.tokensByElement = new IndexedMultimap();
  }

  Object.defineProperty(TokenListObserver.prototype, "started", {
    get: function get() {
      return this.elementObserver.started;
    },
    enumerable: true,
    configurable: true
  });

  TokenListObserver.prototype.start = function () {
    this.elementObserver.start();
  };

  TokenListObserver.prototype.stop = function () {
    this.elementObserver.stop();
  };

  TokenListObserver.prototype.refresh = function () {
    this.elementObserver.refresh();
  };

  Object.defineProperty(TokenListObserver.prototype, "element", {
    get: function get() {
      return this.elementObserver.element;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(TokenListObserver.prototype, "selector", {
    get: function get() {
      return "[" + this.attributeName + "]";
    },
    enumerable: true,
    configurable: true
  });

  TokenListObserver.prototype.getElementsMatchingToken = function (token) {
    return this.tokensByElement.getKeysForValue(token);
  }; // Element observer delegate


  TokenListObserver.prototype.matchElement = function (element) {
    return element.hasAttribute(this.attributeName);
  };

  TokenListObserver.prototype.matchElementsInTree = function (tree) {
    var match = this.matchElement(tree) ? [tree] : [];
    var matches = Array.from(tree.querySelectorAll(this.selector));
    return match.concat(matches);
  };

  TokenListObserver.prototype.elementMatched = function (element) {
    var newTokens = Array.from(this.readTokenSetForElement(element));

    for (var _i = 0, newTokens_1 = newTokens; _i < newTokens_1.length; _i++) {
      var token = newTokens_1[_i];
      this.elementMatchedToken(element, token);
    }
  };

  TokenListObserver.prototype.elementUnmatched = function (element) {
    var tokens = this.getTokensForElement(element);

    for (var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++) {
      var token = tokens_1[_i];
      this.elementUnmatchedToken(element, token);
    }
  };

  TokenListObserver.prototype.elementAttributeChanged = function (element) {
    var newTokenSet = this.readTokenSetForElement(element);

    for (var _i = 0, _a = Array.from(newTokenSet); _i < _a.length; _i++) {
      var token = _a[_i];
      this.elementMatchedToken(element, token);
    }

    for (var _b = 0, _c = this.getTokensForElement(element); _b < _c.length; _b++) {
      var token = _c[_b];

      if (!newTokenSet.has(token)) {
        this.elementUnmatchedToken(element, token);
      }
    }
  }; // Private


  TokenListObserver.prototype.elementMatchedToken = function (element, token) {
    if (!this.tokensByElement.has(element, token)) {
      this.tokensByElement.add(element, token);

      if (this.delegate.elementMatchedTokenForAttribute) {
        this.delegate.elementMatchedTokenForAttribute(element, token, this.attributeName);
      }
    }
  };

  TokenListObserver.prototype.elementUnmatchedToken = function (element, token) {
    if (this.tokensByElement.has(element, token)) {
      this.tokensByElement.delete(element, token);

      if (this.delegate.elementUnmatchedTokenForAttribute) {
        this.delegate.elementUnmatchedTokenForAttribute(element, token, this.attributeName);
      }
    }
  };

  TokenListObserver.prototype.getTokensForElement = function (element) {
    return this.tokensByElement.getValuesForKey(element);
  };

  TokenListObserver.prototype.readTokenSetForElement = function (element) {
    var tokens = new Set();
    var value = element.getAttribute(this.attributeName) || "";

    for (var _i = 0, _a = value.split(/\s+/); _i < _a.length; _i++) {
      var token = _a[_i];

      if (token.length) {
        tokens.add(token);
      }
    }

    return tokens;
  };

  return TokenListObserver;
}();

export { TokenListObserver };